export default "__VITE_ASSET__CVeDx8Zh__"